export const skyColor = '#87ceeb';
export const groundColor = '#ff6';
export const boardColor = '#ff7f24';
export const cupColor1 = '#0579f5';
export const cupColor2 = '#fc1212';

export const tinkercadScaleMultiplier = 0.1;
